import { buildExecutiveSummary } from '../lib/analysisEngine';
import { useI18n } from '../lib/i18n';

// Auto-generated plain-language summary shown at the top of the report (under the hero).
// Content comes straight from the engine (buildExecutiveSummary), so it always tracks the
// current assumptions and is identical across the internal page, share page and PDFs.
export default function ExecutiveSummary({ analysis, ils, eur, usd, className = '' }) {
  const { t, lang } = useI18n();
  if (!analysis) return null;
  const { bullets, disclaimer } = buildExecutiveSummary(analysis, ils, lang);
  if (!bullets.length) return null;
  return (
    <section className={`bg-white rounded-[1.75rem] border border-black/[0.06] shadow-premium p-5 md:p-6 mb-6 ${className}`}>
      <div className="flex items-center gap-2 mb-3">
        <h3 className="font-semibold text-gray-800">{t('executive_summary')}</h3>
        <span className="text-[10px] uppercase tracking-wide text-gray-400 bg-gray-50 border border-black/[0.06] rounded-full px-2 py-0.5">{t('auto_generated')}</span>
      </div>
      <ul className="space-y-2.5">
        {bullets.map((b, i) => (
          <li key={i} className="flex gap-2.5 text-sm text-gray-600 leading-snug">
            <span className="shrink-0 text-base leading-tight" aria-hidden="true">{b.icon}</span>
            <span>
              <span className="font-semibold text-gray-900">{b.label}:</span>{' '}
              {b.segments.map((s, j) => s.b
                ? <strong key={j} className="font-semibold text-gray-900 tabular-nums">{s.t}</strong>
                : <span key={j}>{s.t}</span>)}
            </span>
          </li>
        ))}
      </ul>
      <p className="mt-4 text-[11px] italic text-gray-400 leading-snug">{disclaimer}</p>
    </section>
  );
}
